const BASE_RECONNECT_DELAY_MS = 1_000;
const MAX_RECONNECT_DELAY_MS = 30_000;

/** Reconnect attempts after a closed SSE before the stream stays down until a reload. */
export const SSE_MAX_RETRY_COUNT = 10;

/** Exponential backoff with up to 25% jitter: min(1s · 2^attempt, 30s). */
export const getSseReconnectDelay = (attempt: number): number => {
  const exponentialDelay = Math.min(BASE_RECONNECT_DELAY_MS * Math.pow(2, attempt), MAX_RECONNECT_DELAY_MS);
  return exponentialDelay + Math.random() * 0.25 * exponentialDelay;
};
